import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Checkbox from '@mui/joy/Checkbox';
import Typography from '@mui/joy/Typography';   
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import ListService from "../../../services/listService";
import AccountService from "../../../services/accountService";

function ModalEditAccount( {handleOpen, isOpen, modelSelected, modelSelectedHandle}) {

    const [sending, setSending] = useState(false);
    const [listPortfolioManagers, setListPortfolioManagers] = useState([])

    useEffect(() => {
        ListService.getPortfolioManagersList()
            .then((response) => {
                setListPortfolioManagers(response.data)
            })
     }, []);

    const doSave = async () => {
        setSending(true)
        if(validateForm()){
            let model = {
                account: modelSelected.account,
                name: modelSelected.name,
                portfolio_manager_id: modelSelected.portfolio_manager_id,
                emails: modelSelected.emails,
                is_internal: modelSelected.is_internal,
                person_type_id: modelSelected.person_type_id
            }
            AccountService.putAccount(modelSelected.id,model)
                .then((response) => {
                    toast.success('Comitente actualizado!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })
                .catch((error) => {
                    if(error.response.status !== 401){
                        Swal.fire({
                            title: 'Ooops?',
                            text: error.response.data.errors[0].detail,
                            icon: 'error',
                
                        })
                    }else{
                        sessionStorage.removeItem("userProfile");
                        window.location.reload();
                    }
                })
                .finally(() => {
                    setSending(false)
                    handleOpen(false)
                })
        }else{
            toast.error('Cargue los datos correctamente!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        setSending(false)
    }

    const doChangePortfolioManager = (obj) => { 
        if(obj !== null){
            modelSelectedHandle({
                ...modelSelected, 
                portfolio_manager_id: obj.id,
                portfolio_manager: obj.name
            })
        }
    }

    function validateForm (){
        let rta = true;
        if(modelSelected.portfolio_manager_id === '' || modelSelected.portfolio_manager_id === undefined  || modelSelected.portfolio_manager_id === null){ return false; } 
        return rta;
    }

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Editar Comitente</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={6}>
                            <div>
                                <label className="form-label" htmlFor="basic-default-nombre-selected">Código</label>
                                <input type="text" className="form-control" id="basic-default-nombre-selected" placeholder=""                                
                                    value={modelSelected.account} disabled={true}
                                />
                            </div>
                        </Grid>
                        <Grid xs={6}>
                            <div>
                                <label className="form-label" htmlFor="basic-default-codigo-selected">Nombre</label>
                                <input type="text" className="form-control" id="basic-default-codigo-selected" placeholder=" "                                
                                    value={modelSelected.name} disabled={true}
                                />
                            </div>
                        </Grid>
                        <Grid xs={6}>
                            <div>
                                <label className="form-label" htmlFor="basic-default-codigo-selected">Adm. Cartera</label>
                                <input type="text" className="form-control" id="basic-default-codigo-selected" placeholder=" "                                
                                    value={modelSelected.account_manager} disabled={true}
                                />
                            </div>
                        </Grid>
                        <Grid xs={6}>
                            <div>
                                <label className="form-label">Tipo de Persona</label>
                                <input type="text" className="form-control" placeholder=" "                                
                                    value={modelSelected.person_type?.display_name ?? ''} disabled={true}
                                />
                            </div>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Oficial de Cuenta <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    onChange={(event, newValue) => doChangePortfolioManager( newValue) }
                                >
                                    {listPortfolioManagers.map( (manager) => 
                                        <Option value={manager} key={manager.id} label={manager.name}>{manager.name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <div>
                                <label className="form-label" htmlFor="basic-default-codigo-selected">Perfil</label>
                                <input type="text" className="form-control" id="basic-default-codigo-selected" placeholder=" "                                
                                    value={modelSelected.risk_profile} disabled={true}
                                />
                            </div>
                        </Grid>
                        <Grid xs={6}>
                            <Checkbox size="md" color="neutral" checked={modelSelected.is_internal} disabled={true} className="pt-4"
                                label={<Typography variant="label" className="MuiFormLabel-root form-labels css-1ckvkg0-JoyFormLabel-root">Uso interno</Typography>}
                            /> 
                        </Grid>
                        <Grid xs={12}>
                            <div>
                                <label className="form-label" htmlFor="basic-default-codigo-selected">Mail</label>
                                <input type="text" className="form-control" id="basic-default-codigo-selected" placeholder=""                                
                                    value={modelSelected.emails} disabled={true}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info" onClick={() => doSave() } disabled={sending}> Guardar </button>
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalEditAccount;